// import style from './style.module.less';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Button } from 'antd';
import s from './style.module.less';

@inject('store')
@observer
class Error403 extends Component {
    constructor(props) {
        super(props);
    }
    outLogin = () => {
        const {
            store: { login }
        } = this.props;
        login.outLogin();
    };
    componentDidMount() {
        const { store: { login } } = this.props;
        login.getLoginAndOutConfig();
    }
    render() {
        const { store: { login } } = this.props;
        let tenantName = sessionStorage.getItem('tenantName');
        return (
            <div className={s.app}>
                <div className={s['app_logo']}></div>
                <div className={s.content}>
                    <h1></h1>
                    <div className={s.content_main}>
                        <Row style={{ margin: 'auto 0', padding: '160px' }} gutter="24">
                            <Col span={12} style={{ textAlign: 'right' }}>
                                <div className={s.empty}></div>
                            </Col>
                            <Col span={12} style={{ textAlign: 'left' }}>
                                <div style={{ textAlign: 'center', width: '240px', marginTop: '70px' }}>
                                    {/* <h3 style={{ color: 'red' }}>您暂无{this.props.store.login.userInfo.tenantName || '该租户'}的管理后台权限</h3> */}
                                    <h3 style={{ color: 'red' }}>您暂无{tenantName || '该租户'}的管理后台权限</h3>
                                    <div
                                        style={{
                                            fontSize: '12px',
                                            color: '#999',
                                            margin: '14px 0  28px'
                                        }}
                                    >
                                        如果有需要请联系您的机构管理员
                                    </div>
                                    {login.loginAndOutConfig?.logout_config?.can_logout === 1 && (
                                        <Button type="primary" onClick={this.outLogin} block>
                                            退出登录
                                        </Button>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default Error403;

// const Error403 = () => {
//     return (
//         <div className={style['abnormal']}>
//             <p className={style['text']}>403!</p>
//             <p className={style['text']}>有种距离叫做</p>
//             <p className={style['text']}>你没有权限！</p>
//         </div>
//     );
// };

// export default Error403;
